// removed by extract-text-webpack-plugin
module.exports = {"open-button-row":"open-in-app-modal__open-button-row__2OLTg","app-icon":"open-in-app-modal__app-icon__1_Fyi","open-button-name":"open-in-app-modal__open-button-name__skJI4","button":"open-in-app-modal__button__1rwah","button-app":"open-in-app-modal__button-app__3Dt0z open-in-app-modal__button__1rwah","button-browser":"open-in-app-modal__button-browser__1CWys open-in-app-modal__button__1rwah","spacer":"open-in-app-modal__spacer__3ZnKF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/open-in-app-modal.scss
// module id = 1467
// module chunks = 1